import React from 'react';
import PropTypes from 'prop-types';
import CollapsibleSection from './CollapsibleSection';
import InvoiceTrackingTimeline from './InvoiceTrackingTimeline';

const InvoiceTrackingSection = ({ invoice, getTrackingSteps }) => {
  const steps = getTrackingSteps(invoice);

  return (
    <CollapsibleSection title="Seguimiento de la factura" id="invoice-tracking-section">
      <InvoiceTrackingTimeline steps={steps} />
    </CollapsibleSection>
  );
};

InvoiceTrackingSection.propTypes = {
  invoice: PropTypes.shape({
    id: PropTypes.string,
    status: PropTypes.string,
    historystatusSet: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  getTrackingSteps: PropTypes.func,
};

InvoiceTrackingSection.defaultProps = {
  getTrackingSteps: () => [],
};

export default InvoiceTrackingSection;
